// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/finance.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/finance.proto.
 */
export const file_proto_model_core_place_types_finance = /*@__PURE__*/
  fileDesc("Cipwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2ZpbmFuY2UucHJvdG8SBmNhcm1lbiqSAQoQRmluYW5jZVBsYWNlVHlwZRIiCh5GSU5BTkNFX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIhCh1GSU5BTkNFX1BMQUNFX1RZUEVfQUNDT1VOVElORxABEhoKFkZJTkFOQ0VfUExBQ0VfVFlQRV9BVE0QAhIbChdGSU5BTkNFX1BMQUNFX1RZUEVfQkFOSxADQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM");

/**
 * Describes the enum carmen.FinancePlaceType.
 */
export const FinancePlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_finance, 0);

/**
 * Finance-related place types
 *
 * @generated from enum carmen.FinancePlaceType
 */
export const FinancePlaceType = /*@__PURE__*/
  tsEnum(FinancePlaceTypeSchema);

